import {
  Component,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { NotificationType } from "src/app/models";
import { environment } from "src/environments/environment";
import { TopNotificationService } from "./top-notification.service";

@Component({
    selector: "medpt-top-notification",
    templateUrl: "./top-notification.component.html",
    styleUrls: ["./top-notification.component.scss"],
    standalone: false
})
export class TopNotificationComponent implements OnInit, OnDestroy {
  isHidden: boolean;
  message: string="";
  className: string="";

  notificationSubscription!: Subscription;

  constructor(private notificationService: TopNotificationService) {
    this.isHidden = true;
  }

  ngOnInit() {
    this.notificationSubscription = this.notificationService.getNotification().subscribe((notification :any) => {
      if (notification) {
        this.message = notification.message;
        this.className = notification.type;
        this.isHidden = false;
      } else {
        this.hide();
      }
    });
  }

  ngOnDestroy() {
    this.notificationSubscription.unsubscribe();
  }

  hide() {
    this.isHidden = true;
  }

  loadImage() {
    let imagePath = "";
    switch (this.className) {
      case NotificationType.Warning: {
        imagePath = "warning-white.svg";
        break;
      }
      case NotificationType.Success: {
        imagePath = "success-white.svg";
        break;
      }
      case NotificationType.Error: {
        imagePath = "error-white.svg";
        break;
      }
      case NotificationType.Info: {
        imagePath = "info-white.svg";
        break;
      }
      default: {
        imagePath = "";
        break;
      }
    }

    return imagePath == "" ? "" : environment.cdnEndPoint + "/triport/icons/submenu/" + imagePath;
  }
}
